// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import RequestLog from './RequestLog';
import RequestLogDetails from './RequestLogDetails';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function RequestLogs(props) {
  const { path } = useRouteMatch();

  const isRequestLogs = usePermissionStatusByKey('GET:/admin/request-logs');
  const isRequestLog = usePermissionStatusByKey('GET:/admin/request-logs/:id');

  return (
    <>
      <Box>
        <Switch>
          {isRequestLog && (
            <Route path={`${path}/:id`} render={() => <RequestLogDetails />} />
          )}

          {isRequestLogs && (
            <Route path={`${path}`} render={() => <RequestLog />} />
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default RequestLogs;
